import { render, staticRenderFns } from "./FormularioCtrlStatusComponent.vue?vue&type=template&id=34afe27f"
import script from "./FormularioCtrlStatusComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports